import { render } from "./BAdvancedTable.vue?vue&type=template&id=465d639e&scoped=true&ts=true"
import script from "./BAdvancedTable.vue?vue&type=script&lang=ts"
export * from "./BAdvancedTable.vue?vue&type=script&lang=ts"

import "./BAdvancedTable.vue?vue&type=style&index=0&id=465d639e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465d639e"]])

export default __exports__